import React, { ReactElement } from 'react';
import {
  ClipObject,
  ClipObjectPending,
  instanceOfCompletedClip,
} from '../../../../context/clips';
import sanitizeHtml from '../../../../util/sanitizeHtml';

type RequiredHighlights = NonNullable<ClipObject['highlights']>;
type Highlight = RequiredHighlights[0];

/**
 * @description given an html string - only allow for specific tags to be rendered
 * @param value string
 */
const sanitize = (value: Highlight['highlight']) => {
  return sanitizeHtml(value, {
    // TODO: replace this with mark once default tag on server is updated
    // @see https://www.w3schools.com/tags/tag_b.asp
    allowedTags: ['b'],
  });
};

/**
 * @description given a clip and name - find a highlight
 * @param highlight string
 */
const findHighlightByName = (
  highlights: RequiredHighlights,
  name: Highlight['fieldName']
) => {
  return highlights.find(h => h.fieldName === name);
};

/**
 * @description given an html string - render the highlighted content
 * @param highlight string
 */
const ClipHighlight = ({
  clip,
  className,
  field,
  children,
}: {
  className?: string;
  field: keyof ClipObject;
  children: ReactElement;
  clip: ClipObject | ClipObjectPending;
}) => {
  if (!instanceOfCompletedClip(clip)) {
    return children;
  }
  if (clip.highlights) {
    const highlightItem = findHighlightByName(clip.highlights, field);
    if (highlightItem) {
      return (
        <div
          className={className}
          // eslint-disable-next-line react/no-danger
          dangerouslySetInnerHTML={{
            __html: sanitize(highlightItem.highlight),
          }}
        />
      );
    }
    return children;
  }
  return children;
};

export default ClipHighlight;
